import { useState } from "react";
import { FaSortAlphaDown } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";
import { MdOutlineSecurity } from "react-icons/md";
import { TabsContainer, Tab, Icon, TabText } from "./ProductSlider.style";

const ProductSlider = () => {
    const [activeTab, setActiveTab] = useState("alphabetical");

  return (
    <TabsContainer>
      <Tab active={activeTab === "alphabetical"} onClick={() => setActiveTab("alphabetical")}>
        <Icon><FaSortAlphaDown /></Icon>
        <TabText>Orden Alfabético</TabText>
      </Tab>
      <Tab active={activeTab === "function"} onClick={() => setActiveTab("function")}>
        <Icon><FiSettings /></Icon>
        <TabText>Por Función</TabText>
      </Tab>
      <Tab active={activeTab === "system"} onClick={() => setActiveTab("system")}>
        <Icon><MdOutlineSecurity /></Icon>
        <TabText>Por Sistema</TabText>
      </Tab>
    </TabsContainer>
  );
};

export default ProductSlider;